import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { stringify } from "qs";
import { AddUserKnowMsgLogRequest } from "./noticeLimit";
const { cs } = baseUrl;

class Basic {
  /** 获取消息记录,已读未读，按照年份分组返回(公告列表) */
  GetUserMessageList() {
    return axios.get(`${cs}/PutUserMessage/GetUserMessageList`);
  }
  /** 获取未读消息数量（公告未读数量） */
  GetUserMessageCount() {
    return axios.get(`${cs}/PutUserMessage/GetUserMessageCount`);
  }
  /** 给当前用户添加一条该文章的我知道了信息（立即了解按钮点击时） */
  AddUserKnowMsgLog(params: AddUserKnowMsgLogRequest) {
    return axios.post(`${cs}/PutUserMessage/AddUserKnowMsgLog?${stringify(params)}`);
  }
  /** 获取未过期，未查看或者未知道的系统公告数据（刚登录成功调用，有数据则弹窗）测试img路径前拼接：http://manage.crs.91yikuaiji.com/，正式拼接：http://xkj.yundaizhang.com/ */
  GetUserNotReadNotice() {
    return axios.get(`${cs}/PutUserMessage/GetUserNotReadNotice`);
  }
  /** 给当前用户添加一条该文章的已读信息（查阅公告时） */
  AddUserReadMsgLog(params: AddUserKnowMsgLogRequest) {
    return axios.post(`${cs}/PutUserMessage/AddUserReadMsgLog?${stringify(params)}`);
  }
}

// 单列模式返回对象
let instance;
export default (() => {
  if (instance) return instance;
  instance = new Basic();
  return instance;
})();
